<template>
  <MapWidget
    class="worst-addresses-widget"
    :title="$t('message.dashboard.widgetTitle.lowestQualityGmbAddresses')"
    :tooltip="$t('message.dashboard.widgetTooltip.lowestQualityGmbAddresses')"
    :marker-type="markerType"
    :data="data"
    :action-handler="actionHandler"
    :loading="loading"
  >
    <template v-slot="item">
      <div class="rating-row" v-if="item.score !== null">
        <div class="rating-label">
          {{ $t("message.dashboard.addressScore", [Math.round(item.score)]) }}
        </div>
        <ui-button
          transparent
          small
          :to="{
            name: 'profile-facility-details',
            params: { id: item.facility_id }
          }"
          @click.native="handleClick(item.gmb_address_id)"
        >
          {{ $t("message.common.more") }}
        </ui-button>
      </div>
    </template>
  </MapWidget>
</template>

<script>
import MapWidget from "@/components/Dashboard/base/MapWidget";

import { numberedSecondary } from "@/config/marker";
import { dashboardWidget } from "@/helpers/mixins/dashboard-widget";
import { GTM_EVENT_NAME } from "@/enums/gtm-events";

export default {
  name: "DashboardLowestQualityAddressesWidget",
  components: {
    MapWidget
  },
  mixins: [dashboardWidget],
  data() {
    return {
      markerType: numberedSecondary
    };
  },
  methods: {
    handleClick(id) {
      this.$gtm.trackCustomEvent({
        event: GTM_EVENT_NAME.DASHBOARD_SHOW_DETAILS,
        component: "lowest_quality_locations",
        location_id: id
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.rating-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: normal;
  @include font-size(14px);
  line-height: 17px;
}

.rating-label {
  color: $dark;
  opacity: 0.5;
}
</style>

<style lang="scss">
.worst-addresses-widget {
  .map-widget-marker {
    color: $dashboard-negative-color !important;
  }

  .v-list .v-list-item .list-item-index {
    border-color: $dashboard-negative-color;
    color: $dashboard-negative-color;
  }
}

.v-btn:not(.v-btn--round).v-size--small {
  height: 26px;
}
</style>
